import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import useWebView from '../hooks/useWebView';

const Label = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  font-weight: 600;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StudentAlert = styled.div`
  color: red;
  font-size: 12pt;
  margin-top: 8px;
`;

type CardData = {
  hopCardId: string;
};

type ResData = {
  data: Array<{
    card_no:string;
    card_status: string;
    card_type: string;
    card_expire: string | null;
  }>;
};


type ResDataLogin = {
    token: string;
  };

type Props = {
  cardNumber: string | null;
  onCheckStudentChange?: (value: string | null) => void; // Add this
};

const CardChecker: React.FC<Props> = ({ cardNumber ,onCheckStudentChange }) => {
  const [cardType, setCardType] = useState<string | null>(null);
  const [txtExpireDate, setTxtExpireDate] = useState<string | null>(null);
  const [expireDate, setExpireDate] = useState<Date | null>(null);
  const [checkStudent, setCheckStudent] = useState<string | null>(null);
  const [txtAlert, setTxtAlert] = useState('');
  const isWebView = useWebView();

  useEffect(() => {

    const getHopCardData = async () => {
   
  
      const data: CardData = {
          hopCardId: cardNumber ?? ''
  
        };
      try {
          const respLogin = await axios.post<ResDataLogin>(
              'https://crdchk.divineconnect.co.th/Card/login'
            );
           
        
      
  
            const response = await axios.post<ResData>('https://crdchk.divineconnect.co.th/Card/checkCardRegister',
            data,
            {
              headers: {
                'authorization': 'Bearer ' + respLogin.data.token
              }
            });
  
        const resData = response.data;
  
        const cardInfo = resData.data[0];
  
        if (cardInfo.card_status === "อายัด"){
          window.location.replace("/status/suspended?card_no=" + cardNumber);
        }
  
        if (cardInfo.card_type !== '') {
          setCardType(cardInfo.card_type);
        }
  
        if (cardInfo.card_type === 'STUDENT') {
          if (cardInfo.card_expire === null ) {
            setCheckStudent("0");
            
                window.location.replace(
                    `/status/student-register-information`
                );
            
           
          } else {
            setCheckStudent("1");
    
            const date = (new Date(cardInfo.card_expire)).getTime();
   
            const today = (new Date()).getTime();
            const msDay = 24 * 60 * 60 * 1000; // milliseconds per day
            
            const days = Math.floor((today - date) / msDay);
            if (days > 0){
              window.location.replace("/status/expired?card_no=" + cardNumber);
            }
  
            
              const tmpDate = new Date(cardInfo.card_expire);
  
              setExpireDate(tmpDate);
              setTxtExpireDate(
                ` ( หมดอายุวันที่ ${tmpDate.toLocaleDateString('en-GB', {
                  timeZone: 'Asia/Bangkok',
                })} )`
              );
          
          }
  
          
        }
      } catch (error) {
       // console.error('Error:', error);
      }
  
  
      
  
    };

    if (cardNumber) {
      getHopCardData();
    }
  }, [cardNumber, isWebView]);

  useEffect(() => {
    if (checkStudent === '0') {
      setTxtAlert('โปรดลงทะเบียนก่อนใช้งานบัตร'); // Set your alert message
      if (onCheckStudentChange) onCheckStudentChange(checkStudent);
    } else {
      setTxtAlert('');
    }
  }, [checkStudent, onCheckStudentChange]);

  

  let isExpired = false;
  let  isExpiredWarn = false;
  if (expireDate){
    const date = (new Date(expireDate)).getTime();
 
    const today = (new Date()).getTime();
    const msDay = 24 * 60 * 60 * 1000; // milliseconds per day
    
    const days = Math.floor((today - date) / msDay);
    if (days > 0){
      isExpired = true;
    }
    
    if (days <= 0 && days >= -7){
      isExpiredWarn = true;
    }
  

  }

     const textExpireDateAlert = {
       color: isExpired  ? 'red' : isExpiredWarn ? 'orange' : 'black', // red if expired
       fontWeight: isExpired  ? 'bold' : isExpiredWarn ? 'bold': 'normal',
     };

  return (
    <InputContainer>
         <Label>ประเภทบัตร:</Label>
         <div>{cardType ?? '-'} <span style={textExpireDateAlert}>{txtExpireDate}</span></div>
         <input type="hidden" id="checkStudent" value={checkStudent ?? ''} ></input>
         {checkStudent === '0' && <StudentAlert>{txtAlert}</StudentAlert>}
         
    </InputContainer>
     

  );
};

export default CardChecker;